<template v-slot="props">
  <div v-if="isTaskTemplate">
    <a href="#" v-if="canEdit" @click.prevent="handleEditTaskTemplate">
      {{ taskTemplate.name }}
    </a>
    <span v-else>{{ taskTemplate.name }}</span>
  </div>
</template>

<script>
import Permissions from '@/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    isTaskTemplate() {
      return !!(this.data && this.data.id)
    },
    taskTemplate() {
      return this.data
    },
    canEdit() {
      return this.$can('edit', Permissions.TASK_TEMPLATES)
    }
  },
  methods: {
    handleEditTaskTemplate() {
      this.$eventHub.$emit('show-modal-1', 'Task Template', {id: this.data.id}, '1100px')
    },
  }
}
</script>
